<script setup>
import Icon from './Icon.vue';

defineOptions({ name: 'DsSelect', inheritAttrs: false });

defineProps({
  modelValue: { type: [String, Number], default: '' },
  size: { type: String, default: 'md' },
  options: { type: Array, default: () => [] },
  placeholder: { type: String, default: null }
});

defineEmits(['update:modelValue']);

function optValue(o) { return typeof o === 'string' ? o : o.value; }
function optLabel(o) { return typeof o === 'string' ? o : o.label; }
</script>

<template>
  <div :class="['ds-select', `ds-select--${size}`]">
    <!-- eslint-disable vuejs-accessibility/form-control-has-label —
         primitiva: la etiqueta la aporta el componente Field que la envuelve. -->
    <select
      class="ds-select__field"
      :value="modelValue"
      v-bind="$attrs"
      @change="$emit('update:modelValue', $event.target.value)"
    >
      <!-- eslint-enable vuejs-accessibility/form-control-has-label -->
      <option
        v-if="placeholder"
        value=""
      >
        {{ placeholder }}
      </option>
      <option
        v-for="o in options"
        :key="optValue(o)"
        :value="optValue(o)"
      >
        {{ optLabel(o) }}
      </option>
    </select>
    <Icon
      name="chevDown"
      :size="14"
      class="ds-select__chev"
    />
  </div>
</template>
